import { gql } from '@apollo/client'

export const GET_FIXTURE_TYPES = gql`
  query GetFixtureTypes($input: FixtureTypesInput) {
    fixtureTypes(input: $input) {
      id
      name
    }
  }
`
